module.exports = __webpack_public_path__ + "static/media/dumpster-icon-active.9de26a9a.svg";